import { z } from "zod"
import { statusMap } from "./cases"

const idSchema = z.guid()

const missedInboundCallReportSchema = z.object({
  _id: idSchema,
  entor_id: idSchema,
  legacy_id: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  first_name_kana: z.string(),
  last_name_kana: z.string(),
  status: z.enum(statusMap),
  campaign_id: z.string(),
  call_comment: z.string().nullable(),
  created_at: z.iso.datetime(),
})

type MissedInboundCallReport = z.infer<typeof missedInboundCallReportSchema>

export { idSchema, missedInboundCallReportSchema, type MissedInboundCallReport }
